import { DEFAULT_RESUME_FILTERS } from "../constants/filters";

const normalizeArrayParam = (value) => {
  if (Array.isArray(value)) {
    return value.filter(Boolean).join(",");
  }
  return value || "";
};

export const buildResumeSearchParams = (filters = {}) => {
  const merged = { ...DEFAULT_RESUME_FILTERS, ...filters };

  return {
    q: merged.q || "",
    skills: normalizeArrayParam(merged.skills),
    tags: normalizeArrayParam(merged.tags),
    experienceMin: merged.experienceMin || "",
    experienceMax: merged.experienceMax || "",
    location: merged.location || "",
    source: merged.source || "",
    status: merged.status || "",
    page: Number(merged.page) || 1,
    limit: Number(merged.limit) || 20,
  };
};

export const toQueryString = (params = {}) => {
  const searchParams = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null || value === "") {
      return;
    }
    searchParams.set(key, String(value));
  });

  return searchParams.toString();
};

export const parseFiltersFromQuery = (search = "") => {
  const searchParams = new URLSearchParams(search);

  return {
    ...DEFAULT_RESUME_FILTERS,
    q: searchParams.get("q") || "",
    skills: (searchParams.get("skills") || "")
      .split(",")
      .map((value) => value.trim())
      .filter(Boolean),
    tags: (searchParams.get("tags") || "")
      .split(",")
      .map((value) => value.trim())
      .filter(Boolean),
    experienceMin: searchParams.get("experienceMin") || "",
    experienceMax: searchParams.get("experienceMax") || "",
    location: searchParams.get("location") || "",
    source: searchParams.get("source") || "",
    status: searchParams.get("status") || DEFAULT_RESUME_FILTERS.status,
    page: Number(searchParams.get("page") || DEFAULT_RESUME_FILTERS.page),
    limit: Number(searchParams.get("limit") || DEFAULT_RESUME_FILTERS.limit),
  };
};
